module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_1-47ba9819d014c8408b803446d805fe2a.jpg";